export type CampaignOrganizerPriority = 'low' | 'medium' | 'high' | 'critical';

export const campaignOrganizerPriorities: CampaignOrganizerPriority[] = [
  'low',
  'medium',
  'high',
  'critical',
];

export interface ICampaignOrganizer {
  id?: number;
  name: string;
  mainImagePath?: string | null;
  priority: CampaignOrganizerPriority;
  // Optional today: the API will expose `enabled` on the element response once
  // the soft-delete fields are surfaced. When present, `false === soft-deleted`,
  // which the list page uses to render a strikethrough + Deleted badge.
  enabled?: boolean;
  createdAt?: string;
  createdAtLocal?: string;
}
